import { Phone } from "react-feather";
function ContactIcon(){    

    return (
        <>        
            <a href="https://wa.me/254794072134" rel="noreferrer" target='_blank' className="wappcomms btn-hover float-left">
                <Phone className='text-white'/>
            </a>
        </>
    )
}

export default ContactIcon;
